import { Stripe } from '@stripe/stripe-js';
import * as payment from '@webapp/sdk/payment';
import { handlePaymentThatRequiresCustomerAction } from './requires-customer-action';
import { handleRequiresPaymentMethod } from './requires-payment-method';
import { Coupon } from '@services/product/types/coupon';
import { CustomerMetadata } from '@services/payment/types/api/customer-metadata';

export const createSubscription = async (
  stripe: Stripe,
  clientId: string,
  paymentMethodId: string,
  externalPriceId: string,
  subscriptionId: string,
  customer: CustomerMetadata,
  externalSubscriptionId?: string,
  coupon?: Coupon,
  isNew?: boolean,
  trialDays?: number
) => {
  let result;

  if (isNew) {
    result = await payment.createRecurringPayment(
      clientId,
      subscriptionId,
      paymentMethodId,
      externalPriceId,
      customer,
      coupon?.externalId,
      trialDays
    );
  } else {
    result = await payment.updateRecurringPayment(
      clientId,
      paymentMethodId,
      subscriptionId,
      externalSubscriptionId as string,
      externalPriceId,
      customer,
      coupon?.externalId
    );
  }

  if (result.error) {
    // The card had an error when trying to attach it to a customer.
    throw result;
  }

  // Some payment methods require a customer to be on session
  // to complete the payment process. Check the status of the
  // payment intent to handle these actions.
  const actionRequieredResponse = await handlePaymentThatRequiresCustomerAction(
    stripe,
    {
      paymentMethodId,
      priceId: externalPriceId,
      subscription: result,
    }
  );

  // If attaching this card to a Customer object succeeds,
  // but attempts to charge the customer fail, you
  // get a requires_payment_method error.
  const requiresPaymentMethodResponse = await handleRequiresPaymentMethod(
    actionRequieredResponse
  );

  return requiresPaymentMethodResponse;
};
